<template>
	<div
		class="prose max-w-none bg-gray-50 pb-[140px] antialiased sm:pb-[120px]"
	>
		<PartnerHeader />

		<div class="lg:mt-10 lg:min-h-[670px] xl:min-h-[620px]">
			<slot />
		</div>

		<PartnerFooter />
	</div>
</template>

<script setup>
import PartnerHeader from '@/components/headers/PartnerHeader.vue'
import PartnerFooter from '@/components/footers/PartnerFooter.vue'

const route = useRoute()
const runtimeConfig = useRuntimeConfig()

if (!route.meta.disableGenericCanonical) {
	useHead(() => ({
		link: [
			{
				rel: 'canonical',
				href: runtimeConfig.public.APP_URL + route.path,
			},
		],
	}))
}
</script>
